module.exports = __webpack_public_path__ + "static/asb-0f10d87c3e299f1ad82bdf847f8ceae2.png";